// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fUmU","newExpiryDate":"styles_newExpiryDate__3lNTU","footer":"styles_footer__3YDIC"};